export const ACTIVATION_STEPS = {
  BUSINESS_PROFILE: "Business Profile",
  VERIFY_FACEBOOK_PAGE: "Verify Facebook Page",
  PHONE_EMAIL_VERIFICATION: "Phone And Email Verification",
  WITHDRAWAL_ACTIVATION: "Withdrawal Activation",
  FACEBOOK_ACTIVATION: "Verify Facebook Page"
};
